import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { psServicesTable } from '../model/psServices';


@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  appToken: string = localStorage.getItem('appToken');//environment.appTokenUser;

  constructor(
    private _http: HttpClient,
    private _toast: ToastrService
  ) { 
    // const emisorData = JSON.parse(localStorage.getItem('emisorData'));
    // console.log(emisorData.emisorData[0].UUID_EMISOR)
    // console.log(this.appToken)
    // this.appToken = emisorData.emisorData[0].UUID_EMISOR
  }

  async getCatalog(): Promise<any>{
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    const day = new Date().getDate();
    const $this = this;
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.getAllCatalog}${$this.appToken}/ALL/${year}/${month}/${day}`;
        const res = await $this._http.get<any>(url);
        res.subscribe(
          async (data) => {
            // console.log(data);
            data = data.dataSet;
            data.data.forEach((element: any) => {
              // console.log(element)
              element.J_ANTICIPADO_TAX = JSON.parse(element.J_ANTICIPADO_TAX);
              element.J_RETENIDO_TAX = JSON.parse(element.J_RETENIDO_TAX);
              element.J_TAX = JSON.parse(element.J_TAX);
              element.PRICE = JSON.parse(element.PRICE);
            });
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      }
      catch (err) {
        console.log(err);
        reject(err);
      }
    });
  };

  async chkDocs(data: any, auth: any): Promise<any> {
    // console.log(data)
    return await this._http.post<any>( environment.endPoints.chkDTE, {
      'auth': JSON.stringify(auth),
      'data': JSON.stringify(data)
    });
  }

//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getCategorias(type? : boolean): Promise<any>{
  const $this = this;
  $this.appToken = localStorage.getItem('appToken');
  var url;
  return await new Promise (async function(resolve, reject) {
    try {
      if(type == true)
          url = await $this._http.get(`${environment.endPoints.categorias}${$this.appToken}/Y`);
      else
          url = await $this._http.get(`${environment.endPoints.categorias}${$this.appToken}`);
      url.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
// Obtener familias del catalogo
async getGroups(type? : boolean): Promise<any>{
  const $this = this;
  $this.appToken = localStorage.getItem('appToken');
  var url;
  return await new Promise (async function(resolve, reject) {
    try {
      if(type == true)
          url = await $this._http.get(`${environment.endPoints.groups}${$this.appToken}/Y`);
      else
          url = await $this._http.get(`${environment.endPoints.groups}${$this.appToken}`);
      url.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getCurrency(month: number): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  const year = new Date().getFullYear();
  return await new Promise (async function(resolve, reject) {
    try {
      const res = await $this._http.get<any>(`${environment.endPoints.currency}${$this.appToken}/${year}/${month}`);
      res.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////// 
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async setPsServicesPriceFlagUpdate(json): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.psServicesPriceFlagUpdate}`
      json.appToken = $this.appToken
      json.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(json)
                                              })
      data.subscribe(
        (res: any) => {
          this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          console.log(error.error.dataSet.glsStatus)
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble Actualizar Proveedor', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesPriceFlagUpdate(uuidPsServicesPrice : string,uuidSp: string): Promise<any>{
    
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  var url;
  return await new Promise (async function(resolve, reject) {
    try {
          url = await $this._http.get(`${environment.endPoints.psServicesPriceFlagUpdate}/${$this.appToken}/${uuidPsServicesPrice}/${uuidSp}`);
      url.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getFamilys(all? : string): Promise<any>{
  const $this = this;
  var url;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      if(!all ) {
        url=`${environment.endPoints.groups}${$this.appToken}`
      }
      else{
              url=`${environment.endPoints.groups}${$this.appToken}/${all}`
            }

      
      const res = await $this._http.get(url);
      res.subscribe(
        (data: any) => {
          resolve(data.dataSet);
          // console.log(data)
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
      // resolve(res);
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getBrands(type? : boolean): Promise<any>{
  const $this = this;
  var all 
  if(type) all = 'Y'; else all = 'N';
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psbrands}${$this.appToken}/${all}`;
      const res = await $this._http.get<any>(url);
      res.subscribe(
        (data) => {
          // console.log(data);
          data = data.dataSet;
          resolve(data);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
public getpsServicesPagination(
  codCategory        : string
 ,codGroup           : string 
 ,remove             : string
 ,page               : number
 ,perPage            : number
 ,from               : string 
 ,searchTerm         : string 
 ,orderBy            : string 
 ,uuidBrands         : string
): Observable<psServicesTable> {
 const $this = this;
 var url;
 this.appToken = localStorage.getItem('appToken');
 url =  $this.appToken 
 + '/' + codCategory
 + '/' + codGroup	
 + '/' + remove
 + '/' + page	
 + '/' + perPage		
 + '/' + from											
 + '/' + searchTerm			
 + '/' + orderBy
 + '/' + uuidBrands;
url = `${environment.endPoints.getAllCatalogPagination}/${url}`;

 return this._http.get<psServicesTable>(url);
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
  // Obtener producto por codigo
  async getProductByBarcode(barcode: string): Promise<any>{ 
    const $this = this;
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.getPsBarcode}/${$this.appToken}/${barcode}`; 
        const res = await $this._http.get<any>(url);
        res.subscribe(
          (data) => {
            //       
            resolve(data.dataSet.barcodePsServices);
          },
          (error) => {
            console.log(error);
            resolve('-1');
          }
        );
      }
      catch (err) {
        console.log(err);
        resolve('-1');
      }
    });
  }
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsStorageLevelDay(): Promise<any>{
    
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  var url;
  return await new Promise (async function(resolve, reject) {
    try {
          url = await $this._http.get(`${environment.endPoints.storageLevelDay}/${$this.appToken}`);
      url.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async setPsReview(json): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.psReview}`
      json.appToken = $this.appToken
      json.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(json)
                                              })
      data.subscribe(
        (res: any) => {
          this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          console.log(error.error.dataSet.glsStatus)
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble crear Links', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getEpcEsl(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.getEpcEsl}/${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
          resData.dataSet.eslTagUsed.forEach(element => {
            element.ESL_DATA = JSON.parse(element.ESL_DATA);
          });       
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getEpcEslDetail(uuidPsServicesEslTag): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.getEpcEslDetail}/${$this.appToken}/${uuidPsServicesEslTag}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
          resData.dataSet.tagQueue.forEach(element => {
            element.MESSAGE = JSON.parse(element.MESSAGE);
          });       
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async epcSetTag(json): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.epcSetTag}`
      json.appToken = $this.appToken
      json.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(json)
                                              })
      data.subscribe(
        (res: any) => {
          this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble crear Valores', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async epcDelTag (uuidPsServicesEslTag: string): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const res = await $this._http.delete(`${environment.endPoints.epcDelTag}/${$this.appToken}/${uuidPsServicesEslTag}`);
      res.subscribe(
        (data: any) => {
          console  
          resolve(data);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getEpcEslData(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.getEpcEslData}/${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
        //  resData.dataSet.tagQueue.forEach(element => {
        //   element.MESSAGE = JSON.parse(element.MESSAGE);
        //  });       
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getEpcEslpsServices(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.getEpcEslpsServices}/${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
        //  resData.dataSet.tagQueue.forEach(element => {
        //   element.MESSAGE = JSON.parse(element.MESSAGE);
        //  });       
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async uploadImg(file: File,uuidPsServices : string,extraData: any): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.uploadImg}`;
      const formData = new FormData();
      const data = {
        uuid              : null
       ,appToken          : environment.appTokenImg
       ,language          : null
       ,externalParentUUID  : $this.appToken
       ,externalChildUUID   : uuidPsServices
       ,externalData      : extraData
       ,nameImg           : file.name
       ,dateExpired       : "9999/12/31"
       ,uuidSSO           : null
       ,device            : null         
      };
      formData.append('img', file);
      formData.append('data', JSON.stringify(data));
      // let uuidIMG = '';
      const res = await $this._http.post<any>(url, formData);
      await res.subscribe(
        (resData) => {
          // console.log(data);
          resData = resData.dataSet;
          // uuidIMG = resData.data.uuidImg;
          // console.log(uuidIMG);
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};

/*
async uploadImg(file: File,uuidPsServices : string,extraData: any): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.uploadImg}`;
      const formData = new FormData();
      const data = {
        uuid              : null
       ,appToken          : environment.appTokenImg
       ,language          : null
       ,externalParentUUID  : $this.appToken
       ,externalChildUUID   : uuidPsServices
       ,externalData      : extraData
       ,nameImg           : file.name
       ,dateExpired       : "9999/12/31"
       ,uuidSSO           : null
       ,device            : null         
      };
      formData.append('img', file);
      formData.append('data', JSON.stringify(data));
      // let uuidIMG = '';
      const res = await $this.http.post<any>(url, formData);
      await res.subscribe(
        (resData) => {
          // console.log(data);
          resData = resData.dataSet;
          // uuidIMG = resData.data.uuidImg;
          // console.log(uuidIMG);
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
*/
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async attacheImgToProduct(uuidImg: string, uuidPsServices: any): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.addImgToProduct}`;
      const data = {
        "appToken": $this.appToken,
        "language":"es",
        "uuidPsServices": uuidPsServices,
        "uuidImg": uuidImg,
        "typeImg":"R",
        uuidSSO  : null,
        device   : null            
        
     };
      const res = await $this._http.post<any>(url, {
        'data': JSON.stringify(data)
      });
      res.subscribe(
        (subResp: any) => {
          // console.log(data);
          subResp = subResp.dataSet;
          resolve(subResp);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async updateOrRemoveImgProduct(uuidImg: string, uuidPsServices: string, newPosition?: number, typeImg?: string): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.addImgToProduct}`;
      const data = {
        "appToken": $this.appToken,
        "language":"es",
        "uuidPsServices": uuidPsServices,
        "uuidImg": uuidImg,
        "orderImg": newPosition,
        "typeImg":typeImg,
        uuidSSO           : null,
        device            : null            
      };
      // console.log(data);
      const res = await $this._http.patch<any>(url, {
        'data': JSON.stringify(data)
      });
      res.subscribe(
        (subResp: any) => {
          // console.log(data);
          subResp = subResp.dataSet;
          resolve(subResp);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async deattachImgToProduct(uuidImg, uuidPsServices): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.addImgToProduct}`;
      const data = {
        "appToken": $this.appToken,
        "language":"es",
        "uuidPsServices": uuidPsServices,
        "uuidImg": uuidImg,
        "orderImg": 1,
        "typeImg":"R",
        "remove": "Y",
        uidSSO  : null ,
        device  : null            
      };
      const res = await $this._http.patch<any>(url, {
        'data': JSON.stringify(data)
      });
      res.subscribe(
        (subResp: any) => {
          // console.log(data);
          //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
           $this.removeImg(uuidImg)
          //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
          subResp = subResp.dataSet;
          resolve(subResp);
        });
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async removeImg(uuid): Promise<any>{
const $this = this;
this.appToken = localStorage.getItem('appToken');
return await new Promise (async function(resolve, reject) {
  try {
    const url = `${environment.endPoints.uploadImg}/${environment.appTokenImg}/${uuid}`;
    const res = await $this._http.delete<any>(url);
    await res.subscribe(
      (resData) => {
        // console.log(data);
        resData = resData.dataSet;
        // uuidIMG = resData.data.uuidImg;
        // console.log(uuidIMG);
        resolve(resData);
      },
      (error) => {
        console.log(error);
        reject(error);
      }
    );
  }
  catch (err) {
    console.log(err);
    reject(err);
  }
});
};
////////////////////////////////////////////////////////////////// 
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async updateCreateDeleteProductos(product: any, create?: boolean): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  let res: any;
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.getFilteredCatalog}`;
      const data = {
        "appToken": $this.appToken,
        "language":"es",
        "uuidSSO" : null,
        "device"  : null,
        'psServices': [product]
      };

      if(create){
        res = await $this._http.post<any>(url, {
          'data': JSON.stringify(data)
        });
      }else{
        res = await $this._http.patch<any>(url, {
          'data': JSON.stringify(data)
        });
      }

      res.subscribe(
        (subResp: any) => {
          // console.log(data);
          subResp = subResp.dataSet;
          resolve(subResp);
        },
        (error) => {
          console.log(error.error.dataSet.glsStatus     );
          $this._toast.error(error.error.dataSet.glsStatus,'No Actualizado');
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
  // Obtener producto por codigo
  async getProductByCode(uuidPsServices: string): Promise<any>{ 
    const $this = this;
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.getFilteredCatalog}${$this.appToken}/${uuidPsServices}`; 
        const res = await $this._http.get<any>(url);
        res.subscribe(
          (data) => {
            data = data.dataSet;
            //
            data.price.forEach(e => {
              e.EMPLOYEE_CREATION = JSON.parse(e.EMPLOYEE_CREATION)
            });    
            //  
            data.eslTag.forEach(e => {
              e.ESL_DATA = JSON.parse(e.ESL_DATA)
            });
            //       
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      }
      catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async postPsServicesCombination(ps): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.psCombination}`
      ps.appToken = $this.appToken
      ps.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(ps)
                                              })
      data.subscribe(
        (res: any) => {
          this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble crear Combinacion', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async postPsServicesCombinationDetail(ps): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.psCombinationDetail}`
      ps.appToken = $this.appToken
      ps.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(ps)
                                              })
      data.subscribe(
        (res: any) => {
            this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          //this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble crear Combinacion', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async postPsServicesCombinationProperty(ps): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.psCombinationProperty}`
      ps.appToken = $this.appToken
      ps.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(ps)
                                              })
      data.subscribe(
        (res: any) => {
          this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble crear Propiedades', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async postPsServicesCombinationPropertyValue(ps): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise(async (resolve, reject) => {
    try {
      const url = `${environment.endPoints.psCombinationPropertyValue}`
      ps.appToken = $this.appToken
      ps.language = "es"
      
      const data = await $this._http.post(url,{
                                                'data': JSON.stringify(ps)
                                              })
      data.subscribe(
        (res: any) => {
          this._toast.success(res.dataSet.glsStatus, 'Éxito');
          resolve(res);
        },
        (error) => {
          this._toast.warning(error.error.dataSet.glsStatus, 'Alerta');
          reject(error);
        }
      );
    }catch(err) {
      this._toast.error('No es posble crear Valores', 'Error');
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesCombination(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psCombination}/${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
         
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet.psCombination;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesCombinationDetail(uuidPsCombination: string): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psCombinationDetail}/${$this.appToken}/${uuidPsCombination}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
   
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesCombinationProperty(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psCombinationProperty}/${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async psCombinationPs(uuidPsCombination,codPsGroup,idPsType): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken'); 
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psCombinationPs}/${$this.appToken}/${uuidPsCombination}/${codPsGroup}/${idPsType}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
          resData.dataSet.ps.forEach(element => {
            element.PRICE   = JSON.parse(element.PRICE);
          });            
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet.ps;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesCombinationPropertyValue(uuidPsServicesProperty): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psCombinationPropertyValue}/${$this.appToken}/${uuidPsServicesProperty}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesCombinationPropertyValueAll(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.psCombinationPropertyValue}/${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      await res.subscribe(
        (resData) => {
          ////////////////////////////////////////////////////////////////////
          ///////////////////////////////////////////////////////////////////
          resData = resData.dataSet;
          resolve(resData);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
  //Obtener Impuestos
  async getAllTaxes(): Promise<any> {
    const $this = this;
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.taxes}${$this.appToken}`;
        const res = await $this._http.get<any>(url);
        res.subscribe(
          (data) => {
            // console.log(data);
            data = data.dataSet;
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      }
      catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////  
async getPsServicesDiscount(uuidPsServices : string): Promise<any>{
    
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  var url;
  return await new Promise (async function(resolve, reject) {
    try {
          url = await $this._http.get(`${environment.endPoints.psServicesDiscount}/${$this.appToken}/${uuidPsServices}`);
      url.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
  //Obtener items de costos
  async getCostItemsByProduct(uuidPsServices: string): Promise<any>{
    const $this = this;
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.getCostItems}${$this.appToken}/${uuidPsServices}`;
        const res = await $this._http.get<any>(url);
        res.subscribe(
          (data) => {
            // console.log(data);
            data = data.dataSet;
            // data.data.forEach((element: any) => {
            //   // console.log(element)
            //   element.J_ANTICIPADO_TAX = JSON.parse(element.J_ANTICIPADO_TAX);
            //   element.J_RETENIDO_TAX = JSON.parse(element.J_RETENIDO_TAX);
            //   element.J_TAX = JSON.parse(element.J_TAX);
            //   element.PRICE = JSON.parse(element.PRICE);
            // });
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      }
      catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
  //Obtener Costos de un producto
  async getCostsByProduct(uuidPsServices: string): Promise<any>{
    const $this = this;
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.costs}${$this.appToken}/${uuidPsServices}`;
        const res = await $this._http.get<any>(url);
        res.subscribe(
          (data) => {
            data = data.dataSet;
            data.priceOld.forEach(e => {
                e.EMPLOYEE_CREATION = JSON.parse(e.EMPLOYEE_CREATION)
              });
              resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      }
      catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getPsServicesTypeBarcode(): Promise<any>{
    
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  var url;
  return await new Promise (async function(resolve, reject) {
    try {
          url = await $this._http.get(`${environment.endPoints.getPsServicesTypeBarcode}/${$this.appToken}`);
      url.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getAllChargeCodes(): Promise<any>{
  const $this = this;
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const url = `${environment.endPoints.chargeCode}${$this.appToken}`;
      const res = await $this._http.get<any>(url);
      res.subscribe(
        (data) => {
          let x = data.dataSet.data;
          x.forEach((element: any) => {
            // console.log(element);
            element.ATTRIBUTE_CHARGE_CODE = JSON.parse(element.ATTRIBUTE_CHARGE_CODE);
          });
          // console.log(x);
          resolve(x);
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    }
    catch (err) {
      console.log(err);
      reject(err);
    }
  });
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
  async getAllSalesChannels(type? : boolean): Promise<any>{
    const $this = this;
    var all 
    if(type) all = 'Y'; else all = 'N';
    this.appToken = localStorage.getItem('appToken');
    return await new Promise (async function(resolve, reject) {
      try {
        const url = `${environment.endPoints.salesChannel}${$this.appToken}/${all}`;
        const res = await $this._http.get<any>(url);
        res.subscribe(
          (data) => {
            // console.log(data);
            data = data.dataSet;
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      }
      catch (err) {
        console.log(err);
        reject(err);
      }
    });
  };
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getUnitMeasurement(type? : boolean): Promise<any>{
  const $this = this;
  var all 
  if(type) all = 'Y'; else all = 'N';
  this.appToken = localStorage.getItem('appToken');
  const year = new Date().getFullYear();
  return await new Promise (async function(resolve, reject) {
    try {
      const res = await $this._http.get<any>(`${environment.endPoints.unitMeasurement}${$this.appToken}/${all}`);
      res.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
async getTypes(type? : boolean): Promise<any>{
  const $this = this;
  var all 
  if(type) all = 'Y'; else all = 'N';
  this.appToken = localStorage.getItem('appToken');
  return await new Promise (async function(resolve, reject) {
    try {
      const res = await $this._http.get(`${environment.endPoints.types}${$this.appToken}/${all}`);
      res.subscribe(
        (data: any) => {
          resolve(data.dataSet);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      );
    } catch (err) {
      console.log(err);
      reject(err);
    }
  });
}
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
}